<template>
    <v-card class="mx-auto" color="pink" theme="dark" max-width="600" height="100%">
        <v-card-title class="pb-1">
            <v-icon start>$atom</v-icon>
            <span class="text-h6">Source Experiment</span>
        </v-card-title>

        <v-card-text v-if="this.experiment" class="font-weight-bold">
            <span class="h1">Source Protocol:</span>
            <div class="d-flex">
                <div class="d-flex ml-md-8 justify-start">{{ exp.protocol }}</div>
            </div>
            <span class="h1">{{ `Source Experiment: ${exp.name} (${exp.exp})` }}</span>
        </v-card-text>
        <v-card-text v-else>
            <span class="h1 font-weight-bold">Please select a source experiment</span>
        </v-card-text>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ExperimentCard",
    props: ["experiment"],

    computed: {
        exp: function () {
            return {
                name: this.experiment ? this.experiment.name : "",
                exp: this.experiment ? this.experiment.exp : "",
                protocol: this.experiment ? this.experiment.protocol : "",
            };
        },
    },
});
</script>

<style scoped></style>
